import {FC, useState} from "react";
import {decodeBase64, encodeBase64} from "../utils/JWTEncoderUtils";

interface JPGToPDFConverterProps {
    onBack?: () => void;
}

const Base64Encoder: FC<JPGToPDFConverterProps> = ({onBack}) => {

    const [text, setText] = useState("");
    const [encoded, setEncoded] = useState("");
    const [decoded, setDecoded] = useState("");


    const handlePaste = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            setText(clipboardText);
        } catch (err) {
            alert("Unable to read clipboard.");
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(encoded);
        } catch (err) {
            alert("Unable to copy.");
        }
    };
    const handleClear = () => {
        setText("");
        setEncoded("");
        setDecoded("");
    };
    return (
        <div style={{maxWidth: 900, margin: "0 auto", padding: "40px"}}>
            {onBack && (
                <button
                    onClick={onBack}
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#2563eb",
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: "pointer",
                        marginBottom: 24,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        transition: "color 0.15s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = "#1d4ed8")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "#2563eb")}
                >
                    ← Back to Home
                </button>
            )}
            <h2>Base64 Encoder / Decoder</h2>

            <h3>Original Text</h3>
            <textarea
                rows={20}
                value={text}
                onChange={(e) => setText(e.target.value)}
            />

            <br/>

            <button onClick={() => setEncoded(encodeBase64(text))}>
                Encode
            </button>
            <div className="toolbar">
                <button onClick={handlePaste}>📋 Paste</button>
                <button onClick={handleCopy}>📄 Copy</button>
                <button onClick={handleClear}>🗑 Clear</button>
            </div>

            <h3>Encoded</h3>
            <textarea rows={4} value={encoded} onChange={(e) => setEncoded(e.target.value)}  />
            <br/>

            <button onClick={() => setDecoded(decodeBase64(encoded))}>
                Decode
            </button>

            <h3>Decoded</h3>
            <div className="toolbar">
                <button onClick={handlePaste}>📋 Paste</button>
                <button onClick={handleCopy}>📄 Copy</button>
                <button onClick={handleClear}>🗑 Clear</button>
            </div>
            <textarea rows={20} value={decoded} readOnly/>
        </div>
    );
}
export default Base64Encoder;
